import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext({ logo: null, setLogo: () => {} });

export const SettingsProvider = ({ children }) => {
  const [logo, setLogo] = useState(null);
  useEffect(() => { api.get("/settings").then((r) => setLogo(r.data.logo)).catch(() => {}); }, []);
  return <Ctx.Provider value={{ logo, setLogo }}>{children}</Ctx.Provider>;
};

export const useSettings = () => useContext(Ctx);
